var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 135,
    viewBox: "0 0 95 135",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_512_1908)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86.624 17.5172C86.0093 16.3429 84.8035 15.61 83.4794 15.61H82.2736C82.2263 15.1765 82.1002 14.7588 81.8953 14.3647C81.2806 13.1904 80.0747 12.4575 78.7507 12.4575H77.5449C77.4976 12.024 77.3715 11.6063 77.1666 11.2122C76.5518 10.0379 75.346 9.30498 74.0219 9.30498H72.8161C72.7688 8.87151 72.6427 8.45381 72.4378 8.05975C71.8231 6.88544 70.6173 6.15249 69.2932 6.15249H68.0874C68.0401 5.71902 67.914 5.30132 67.7091 4.90726C67.0944 3.73295 65.8885 3 64.5645 3H24.1259C22.6048 3 21.2493 3.96939 20.7685 5.41165L18.1125 13.2929C17.6712 13.1904 17.2141 13.1353 16.757 13.1353C13.8646 13.1353 11.4135 15.208 10.9327 18.061C10.6569 19.6846 10.4599 20.4806 10.3495 20.8589C9.96336 20.9771 9.16735 21.1662 7.54382 21.4421C4.69082 21.9307 2.61806 24.3739 2.61806 27.2663C2.61806 30.1587 4.69082 32.6098 7.54382 33.0905C9.15947 33.3664 9.95548 33.5555 10.3417 33.6737C10.4284 33.9496 10.5466 34.4303 10.7121 35.2579L1.18367 63.5357C0.821137 64.6154 1.00241 65.8134 1.66443 66.7355C2.32645 67.6576 3.40618 68.2171 4.54896 68.2171H5.75478C5.81783 68.8161 6.03851 69.3914 6.40104 69.8879C7.06307 70.8101 8.1428 71.3696 9.28557 71.3696H10.4914C10.5545 71.9686 10.7751 72.5439 11.1377 73.0404C11.7997 73.9625 12.8794 74.5221 14.0222 74.5221H15.228C15.2911 75.1211 15.5117 75.6964 15.8743 76.1929C16.3156 76.8155 16.9461 77.2648 17.6633 77.4933L5.95182 112.179C5.40013 113.818 6.10156 115.615 7.63052 116.434C8.54474 116.931 9.58506 116.986 10.4993 116.663C10.5623 117.869 11.2401 118.988 12.3593 119.587C13.2735 120.076 14.3138 120.139 15.228 119.816C15.2911 121.021 15.9689 122.14 17.088 122.739C18.0022 123.228 19.0425 123.291 19.9568 122.968C20.0198 124.174 20.6976 125.293 21.8167 125.892C22.7309 126.381 23.7713 126.444 24.6855 126.12C24.7485 127.326 25.4263 128.445 26.5455 129.044C27.0577 129.32 27.6409 129.47 28.232 129.47C29.3354 129.47 30.3521 128.973 31.0299 128.107L60.1037 90.8993C61.2071 92.1524 62.8148 92.909 64.5487 92.909C67.4411 92.909 69.8922 90.8362 70.3729 87.9832C70.6488 86.3597 70.8458 85.5637 70.9562 85.1854C71.3423 85.0672 72.1383 84.878 73.754 84.6022C76.607 84.1214 78.6797 81.6704 78.6797 78.778C78.6797 75.8856 76.7646 73.6158 74.0771 73.0089L84.0942 60.1862C84.9217 59.1222 85.0793 57.6563 84.4882 56.4505C83.8971 55.2368 82.644 54.4565 81.3042 54.4565H80.0984C80.0511 54.0546 79.9408 53.6605 79.7595 53.298C79.1684 52.0843 77.9153 51.304 76.5755 51.304H75.3696C75.3223 50.9021 75.212 50.508 75.0307 50.1455C74.4397 48.9318 73.1865 48.1515 71.8467 48.1515H70.6409C70.5936 47.7496 70.4833 47.3555 70.302 46.993C70.0577 46.4886 69.6952 46.0551 69.2617 45.7241L86.4191 21.182C87.1836 20.0944 87.2703 18.6836 86.6555 17.5093L86.624 17.5172Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.0419 19.1562H83.4804L56.3139 58.0107H81.2737L28.1936 125.939L44.626 77.2882H23.457L43.0419 19.1562Z",
    fill: "url(#paint0_linear_512_1908)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0419 19.1562H83.4804L56.3139 58.0107H81.2737L28.1936 125.939L44.626 77.2882H23.457L43.0419 19.1562Z",
    stroke: "#1D074F",
    strokeWidth: 3.36,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3114 16.0039H78.75L51.5834 54.8583H76.5432L23.4632 122.787L39.8955 74.1358H18.7266L38.3114 16.0039Z",
    fill: "url(#paint1_linear_512_1908)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3114 16.0039H78.75L51.5834 54.8583H76.5432L23.4632 122.787L39.8955 74.1358H18.7266L38.3114 16.0039Z",
    stroke: "#1D074F",
    strokeWidth: 3.36,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5829 12.8511H74.0215L46.8549 51.7055H71.8147L18.7347 119.634L35.167 70.983H13.998L33.5829 12.8511Z",
    fill: "url(#paint2_linear_512_1908)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5829 12.8511H74.0214L46.8549 51.7055H71.8147L18.7347 119.634L35.167 70.983H13.998L33.5829 12.8511Z",
    stroke: "#1D074F",
    strokeWidth: 3.36,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8544 9.69873H69.2929L42.1264 48.5532H67.0862L14.0061 116.481L30.4385 67.8306H9.26953L28.8544 9.69873Z",
    fill: "url(#paint3_linear_512_1908)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8544 9.69873H69.2929L42.1264 48.5532H67.0862L14.0061 116.481L30.4385 67.8306H9.26953L28.8544 9.69873Z",
    stroke: "#1D074F",
    strokeWidth: 3.36,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1259 6.54639H64.5644L37.3978 45.4008H62.3577L9.27763 113.329L25.71 64.6783H4.54102L24.1259 6.54639Z",
    fill: "url(#paint4_linear_512_1908)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1259 6.54639H64.5644L37.3978 45.4008H62.3577L9.27763 113.329L25.71 64.6783H4.54102L24.1259 6.54639Z",
    stroke: "#1D074F",
    strokeWidth: 3.36,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M64.5078 88.1958C63.9325 88.1958 63.436 87.7781 63.3414 87.2107C62.3563 81.4101 61.8834 80.9372 56.0828 79.9521C55.5154 79.8575 55.0977 79.361 55.0977 78.7857C55.0977 78.2103 55.5154 77.7138 56.0828 77.6192C61.8834 76.6341 62.3563 76.1612 63.3414 70.3606C63.436 69.7932 63.9325 69.3755 64.5078 69.3755C65.0832 69.3755 65.5797 69.7932 65.6743 70.3606C66.6594 76.1612 67.1323 76.6341 72.9329 77.6192C73.5003 77.7138 73.918 78.2103 73.918 78.7857C73.918 79.361 73.5003 79.8575 72.9329 79.9521C67.1323 80.9372 66.6594 81.4101 65.6743 87.2107C65.5797 87.7781 65.0832 88.1958 64.5078 88.1958Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M64.5084 70.5577C65.5723 76.8548 66.4393 77.7218 72.7364 78.7857C66.4393 79.8497 65.5723 80.7166 64.5084 87.0137C63.4444 80.7166 62.5775 79.8497 56.2804 78.7857C62.5775 77.7218 63.4444 76.8548 64.5084 70.5577ZM64.5084 68.1934C63.3577 68.1934 62.3726 69.0288 62.1755 70.1637C61.7499 72.6857 61.3717 74.2777 60.686 74.9633C60.0003 75.649 58.4083 76.0273 55.8863 76.4529C54.7514 76.642 53.916 77.6272 53.916 78.7857C53.916 79.9443 54.7514 80.9215 55.8863 81.1186C58.4083 81.5441 60.0003 81.9225 60.686 82.6081C61.3717 83.2938 61.7499 84.8858 62.1755 87.4078C62.3647 88.5427 63.3498 89.3781 64.5084 89.3781C65.6669 89.3781 66.6442 88.5427 66.8412 87.4078C67.2668 84.8858 67.6451 83.2938 68.3308 82.6081C69.0164 81.9225 70.6084 81.5441 73.1304 81.1186C74.2653 80.9294 75.1007 79.9443 75.1007 78.7857C75.1007 77.6272 74.2653 76.6499 73.1304 76.4529C70.6084 76.0273 69.0164 75.649 68.3308 74.9633C67.6451 74.2777 67.2668 72.6857 66.8412 70.1637C66.6521 69.0288 65.6669 68.1934 64.5084 68.1934Z",
    fill: "#1D074F"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7559 36.6841C16.1806 36.6841 15.684 36.2664 15.5895 35.699C14.6043 29.8984 14.1314 29.4255 8.33086 28.4404C7.76341 28.3458 7.3457 27.8493 7.3457 27.2739C7.3457 26.6986 7.76341 26.2021 8.33086 26.1075C14.1314 25.1224 14.6043 24.6495 15.5895 18.8489C15.684 18.2815 16.1806 17.8638 16.7559 17.8638C17.3312 17.8638 17.8277 18.2815 17.9223 18.8489C18.9075 24.6495 19.3803 25.1224 25.1809 26.1075C25.7484 26.2021 26.1661 26.6986 26.1661 27.2739C26.1661 27.8493 25.7484 28.3458 25.1809 28.4404C19.3803 29.4255 18.9075 29.8984 17.9223 35.699C17.8277 36.2664 17.3312 36.6841 16.7559 36.6841Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7564 19.046C17.8204 25.3431 18.6873 26.21 24.9844 27.274C18.6873 28.338 17.8204 29.2049 16.7564 35.502C15.6925 29.2049 14.8255 28.338 8.52843 27.274C14.8255 26.21 15.6925 25.3431 16.7564 19.046ZM16.7564 16.6816C15.6058 16.6816 14.6206 17.5171 14.4236 18.6519C13.998 21.1739 13.6197 22.7659 12.934 23.4516C12.2484 24.1373 10.6564 24.5156 8.13437 24.9412C6.99947 25.1303 6.16406 26.1155 6.16406 27.274C6.16406 28.4325 6.99947 29.4098 8.13437 29.6068C10.6564 30.0324 12.2484 30.4107 12.934 31.0964C13.6197 31.7821 13.998 33.3741 14.4236 35.8961C14.6127 37.031 15.5979 37.8664 16.7564 37.8664C17.915 37.8664 18.8922 37.031 19.0893 35.8961C19.5149 33.3741 19.8932 31.7821 20.5788 31.0964C21.2645 30.4107 22.8565 30.0324 25.3785 29.6068C26.5134 29.4177 27.3488 28.4325 27.3488 27.274C27.3488 26.1155 26.5134 25.1382 25.3785 24.9412C22.8565 24.5156 21.2645 24.1373 20.5788 23.4516C19.8932 22.7659 19.5149 21.1739 19.0893 18.6519C18.9001 17.5171 17.915 16.6816 16.7564 16.6816Z",
    fill: "#1D074F"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_512_1908",
    x: 0,
    y: 0,
    width: 94.0625,
    height: 134.47,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.6 0 0 0 0 0.6 0 0 0 0 0.6 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_512_1908"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_512_1908",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_512_1908",
    x1: 53.4687,
    y1: 19.1562,
    x2: 53.4687,
    y2: 125.939,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#4AD800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#46D500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#3BCE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#2AC200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#11B100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03A800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_512_1908",
    x1: 48.7383,
    y1: 16.0039,
    x2: 48.7383,
    y2: 122.787,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A94EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#9643E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#8337C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#7730B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#732EB3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_512_1908",
    x1: 44.0097,
    y1: 12.8511,
    x2: 44.0097,
    y2: 119.634,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#FF63BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#FF0FE0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_512_1908",
    x1: 39.2812,
    y1: 9.69873,
    x2: 39.2812,
    y2: 116.481,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#0FD2E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F8EE2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_512_1908",
    x1: 34.5527,
    y1: 6.54639,
    x2: 34.5527,
    y2: 113.329,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#FDFE0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#FDE40C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#FDD20C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#FDCC0C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcGroup);
export default __webpack_public_path__ + "static/media/ic_group.d0e747543bdc9f9924b70638d7b9c650.svg";
export { ForwardRef as ReactComponent };